import {
  aNetworkBlock,
  aNetworkBlockPage,
  mockNetworkBlocksOperationQuery,
  NetworkBlock,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

// Write operation mutation mocks
export const getMockCreateNetworkBlockOperationMutation = (
  networkBlock: Partial<NetworkBlock>
) => ({
  __typename: 'Mutation',
  createNetworkBlock: {
    __typename: 'CreateNetworkBlock',
    data: aNetworkBlock({
      id: networkBlock.addressBlock,
      ...networkBlock,
    }),
  },
});

export const getMockUpdateNetworkBlockOperationMutation = (
  networkBlock: Partial<NetworkBlock>
) => ({
  __typename: 'Mutation',
  updateNetworkBlock: {
    __typename: 'UpdateNetworkBlock',
    data: aNetworkBlock({
      id: networkBlock.addressBlock,
      ...networkBlock,
    }),
  },
});

export const handlers = [
  mockNetworkBlocksOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          networkBlocks: aNetworkBlockPage(),
        },
      });
    }
  ),
];
